export default __webpack_public_path__ + "static/media/Wristwraps of Vindictive Malice.d717e133.jpg";